import { Box } from '@mui/material';
import React from 'react'

function Layout(props) {
    return ( 
        <Box>
            {props.children}
        </Box>
     );
}

export default Layout;